import { getV1 } from '@/common/utils/ajax'
import { handleHomeHouses, handleHouseViewData, handleWxHeadimg, handleBanner, mapHouseItem, handleCol3, handleFloatDlg } from '@/common/utils/map_view_data'
import { BUILDING_STATUS as STATUS } from '@/constant'

const getDashboard = () => getV1('dashboard')

const getBuildings = (status, per = 3) => getV1('buildings', {
    status: STATUS[status] || status,
    per
}).then(({ items }) => {
    return items.map(mapHouseItem)
}).catch(console.error)

const getConsultants = () => getV1('excellent_consultants').then((data) => {
    data.forEach((item) => {
        handleWxHeadimg(item, 120)
    })
    return data
})

const getRecommend = (position, options) => getV1('recommendation', {
    position,
    ...options
},  )

const getRecommendBuilding = (position, options) => getRecommend(position, options).then((items) => {
    if ('surplus' === position) {
        items = handleCol3(handleHomeHouses(items.slice(0, 3)))
    } else {
        items = handleHouseViewData(items)
    }
    return items
})

const getBanners = (position, params) => getRecommend(position, params).then(handleBanner).catch(err => {
    console.error(err)
    return []
})

const getFloatDlg = (position, params) => getRecommend(position, params).then(handleFloatDlg).catch(err => {
    console.error(err)
    return []
})

export default {
    getDashboard,
    getBuildings,
    getConsultants,
    getRecommendBuilding,
    getBanners,
    getFloatDlg
}
